import { useEffect } from 'react';

type Props = {
  title?: string;
  description?: string;
  canonical?: string | null;
  og?: {
    title?: string;
    description?: string;
    url?: string;
    image?: string;
  };
};

function upsertMeta(name: string, content: string) {
  let el = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertOG(property: string, content: string) {
  let el = document.querySelector<HTMLMetaElement>(`meta[property="${property}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('property', property);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertCanonical(href: string) {
  let el = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

export const SEO: React.FC<Props> = ({ title, description, canonical, og }) => {
  useEffect(() => {
    if (title) document.title = title;
    if (description) upsertMeta('description', description);
    if (canonical) upsertCanonical(canonical);
    if (og?.title) upsertOG('og:title', og.title);
    if (og?.description) upsertOG('og:description', og.description);
    if (og?.url) upsertOG('og:url', og.url);
    if (og?.image) upsertOG('og:image', og.image);
  }, [title, description, canonical, og?.title, og?.description, og?.url, og?.image]);

  return null;
};

export default SEO;

